import MessagingInput from './MessagingInput';

export default MessagingInput;
